import React from 'react';
import SEO from '../../../component/common/SEO';
import { pageSEO } from '../../../config/seoConfig';
import BannerImg from '../../assets/images/common/banner.png';
import './style.css';

export default function HelpCenter() {
  const faqs = [
    {
      section: '1. General Questions',
      items: [
        {
          q: 'Q1: What is Importerr?',
          a: 'Ans: Importerr is India’s AI-powered B2B cross-border sourcing platform. We make global product discovery, sourcing, and importing simple, transparent, and hassle-free.',
        },
        {
          q: 'Q2: Who can use Importerr?',
          a: 'Ans: Anyone looking to import products for business — D2C brands, marketplace sellers, startup founders, students, or even homemakers.',
        },
        {
          q: 'Q3: Is Importerr free to use?',
          a: 'Ans: Signing up and exploring products is free. Certain advanced features like subscriptions and bulk imports may require a premium plan.',
        },
      ],
    },
    {
      section: '2. Product Sourcing & AI Search',
      items: [
        {
          q: 'Q4: How does Importerr help me find products?',
          a: 'Ans: You can search by keywords or upload an image. Our AI scans multiple suppliers globally and presents trending, handpicked products instantly.',
        },
        {
          q: 'Q5: Can I see product details before importing?',
          a: 'Ans: Yes. You can view prices, minimum order quantities (MOQ), variants, colors, and sizes for each product — all in one place.',
        },
      ],
    },
    {
      section: '3. Shopify & Marketplace Integration',
      items: [
        {
          q: 'Q6: Can I connect Importerr with my Shopify or Amazon store?',
          a: 'Ans: Yes. Go to <strong>Marketplace APIs</strong>, choose either <strong>Shopify</strong> or <strong>Amazon</strong>, enter the required details (store domain and API credentials), and sync products directly to your store.',
        },
        {
          q: 'Q7: Can I use Importerr without Shopify or Amazon integration?',
          a: 'Ans: Yes. You can purchase products directly from Importerr and place orders without any Integration.',
        },
        {
          q: 'Q8: What are the benefits of integrating my store with Importerr?',
          a: 'Ans: Integration allows you to <strong>import products directly into your store</strong>, manage inventory seamlessly, and save time on listing and updates.',
        },
      ],
    },
    {
      section: '4. Ordering & Shipping',
      items: [
        {
          q: 'Q9: How does shipping work?',
          a: 'Ans: Importerr manages freight, customs clearance, and delivery in India. We ensure a seamless import experience from the supplier to your doorstep.',
        },
        {
          q: 'Q10: Are there hidden charges?',
          a: 'Ans: No. Importerr is transparent — you see all costs, including product price, shipping, and any applicable taxes.',
        },
        {
          q: 'Q11: What is the delivery timeline?',
          a: 'Ans: Importerr ensures fast and reliable delivery. It typically takes <strong>12–17 days</strong> for products to be delivered, including freight, customs clearance, and last-mile delivery within India. You’ll also receive an estimated delivery timeline at the time of order.',
        },
        {
          q: 'Q12: What payment methods are accepted?',
          a: 'Ans: Payments can be made online via UPI, credit/debit cards, or other secure payment gateways as per your dashboard options.',
        },
      ],
    },
    {
      section: '5. Miscellaneous',
      items: [
        {
          q: 'Q13: Can I import small quantities?',
          a: 'Ans: Yes. Importerr supports a <strong>1-MOQ model</strong>, allowing you to import even a single product without heavy investment — perfect for testing products or starting small.',
        },
        {
          q: 'Q14: Is customer support available?',
          a: 'Ans: Yes. Our team is ready to assist via chat, email, or calls for any queries or guidance.',
        },
      ],
    },
  ];

  return (
    <div className="w-full bg-[#F7F7F7]">
      <SEO {...pageSEO.helpCenter} />
      {/* Banner */}
      <section
        className="hc-banner"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,.45), rgba(0,0,0,.45)), url(${BannerImg})`,
        }}
      >
        <div className="text-center px-4">
          <h1 className="text-white text-4xl md:text-5xl font-bold">Help Center</h1>
          <p className="text-white/90 mt-3 text-sm md:text-base">Let us know how we may help you?</p>
        </div>
      </section>

      {/* FAQ */}
      <section className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        {faqs.map(block => (
          <div key={block.section} className="mb-6 rounded-2xl bg-white border border-black/5 shadow-md overflow-hidden">
            <div className="px-5 md:px-7 py-4 border-b">
              <h2 className="text-lg md:text-xl font-semibold text-slate-900">{block.section}</h2>
            </div>

            <div className="divide-y">
              {block.items.map(item => (
                <details key={item.q} className="group px-5 md:px-7 py-4 open:bg-slate-50 transition">
                  <summary className="flex cursor-pointer items-start justify-between gap-4">
                    <span className="text-slate-900 font-medium">{item.q}</span>
                    <span className="shrink-0 mt-1 rounded-full border border-slate-300 w-6 h-6 grid place-items-center text-slate-500 group-open:rotate-45 transition">
                      +
                    </span>
                  </summary>
                  <p className="mt-3 text-sm md:text-[15px] leading-7 text-slate-700" dangerouslySetInnerHTML={{ __html: item.a }}></p>
                </details>
              ))}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
